import { gsap } from "gsap";

export default function accordionInit(cardShowMoreClass, textSearchClass, paramInstance, followMenuClass) {
  const unionClassName = ".js__data-box";
  // let targetClassName = ".js__accordion-header";
  let targetClassName = ".js__accordion";
  const paramHandler = paramInstance;


  class accordion {
    static instanceList = [];
    static nextId = 1;


    static openFromProp( propertyId ){

      const targetList = accordion.instanceList.filter( instance => instance.propertyId == propertyId );

      if(targetList.length < 1 ) return false;
      [...targetList].forEach( target => { 
        target.bodyShow();
        target.menuOpen(); 
        target.scrollTo();
      });

    }

    static getRootAccordionInstances(dom) {
      let rootAccordionInstances = [];
      let targetClass = ".js__accordion";
    
      function findRootAccordion(element) {
        const target = element.closest(targetClass);
        
        if (target && target.classList.contains('js__accordion')) {
          const accordionId = target.getAttribute('data-accordion-id');
          const accordionInstance = accordion.instanceList.find(instance => instance.id === parseInt(accordionId, 10));
    
          if (accordionInstance) {
            rootAccordionInstances.push(accordionInstance);
          }
        }
    
        if (target && target.parentElement) {
          findRootAccordion(target.parentElement);
        }
      }
    
      findRootAccordion(dom);
    
      return rootAccordionInstances;
    }
    
    
    


    static performActionOnAccordions(accordionInstanceList, actionFn) {
      accordionInstanceList.forEach(instance => {
        // 引数として渡された関数を実行
        instance[actionFn]();
      });
    }

    
    constructor(element , depth = 0) {
      this.instanceType = "accordion";
      this.id = accordion.nextId++;
      this.ele = element;
      this.depth = this.calculateDepth();
      this.ele.setAttribute("data-accordion-id", this.id );
      this.header = this.ele.getElementsByClassName("js__accordion-header")[0] || null;
      this.union = this.header.closest(unionClassName);
      this.unionId = this.union.getAttribute("data-union-id").split(",") || null;
      this.uniqueNum = this.union.getAttribute("data-box-num")? parseInt(this.union.getAttribute("data-box-num")): null;
      this.wrapper = this.header.parentNode.querySelector(".js__accordion-body-wrapper") || null;
      this.body = this.ele.querySelector(".js__accordion-body") || null;
      this.btn = this.ele.querySelector(".js__accordion-btn") || null;
      this.showMore = this.ele.getAttribute("data-show-more") || 0;
      this.iconBox = this.header.querySelector(".js__accordion-icon-box") || null;
      this.propertyId = this.ele.getAttribute("data-property-id") || null;
      this.start = this.header.getAttribute("data-accordion-start") || 0;
      this.tenChild = (this.body.children.length > 9) ? true : false;
      this.open = false;
      this.getHeight = (() => {
        if (this.tenChild === true) {
          let getHeight = 0;
          for (let i = 0; i < 10; i++) {
            getHeight = getHeight + this.body.children[i].clientHeight + 4;
          }
          return getHeight;
        } else {
          return this.body.clientHeight;
        }
      })();
      this.Btn = this.header.parentNode.querySelector(".js__show-more-btn") || null;
      this.BtnElement = (() => {
        let div = document.createElement("div");
        div.className = "js__show-more-btn p-property-box__btn is-hidden";
        let b = document.createElement("b");
        b.innerHTML = "<span><span class=\"visible_if_ja\">さらに表示</span><span class=\"visible_if_en\">Show More</span><span class=\"visible_if_cn\">显示更多</span><span class=\"material-icons-outlined p-material-icon\">expand_more</span></span>";
        div.appendChild(b);
        return div;
      })();
      this.BtnElement.addEventListener("click", this.toggleShow, true);
      if( this.btn !== null ){
        this.btn.addEventListener("click", this.toggleOpen, true);
      }
    }

    
    scrollTo = () => {
      // Get the height of the header
      const headerHeight = document.querySelector('header').offsetHeight;
    
      // Get the bounding client rect of the element
      const rect = this.ele.getBoundingClientRect();
    
      // Scroll to the coordinates of the element, adjusting for the header height
      window.scrollTo({
        top: rect.top + window.scrollY - headerHeight,
        left: rect.left + window.scrollX,
        behavior: 'auto' // You can use 'auto' for instant scrolling
      });
    }

    calculateDepth() {
      let depth = 0;
      let parent = this.ele.parentElement;
  
      while (parent) {
        if (parent.classList.contains('js__accordion')) {
          depth++;
        }
        parent = parent.parentElement;
      }
  
      return depth;
    }

    menuTl = () => {
      let tl = gsap.timeline({ reversed: true, paused: true, ease: "power1.out" });
      tl.from(this.wrapper, { height: 0, duration: 0.1 }).
        to(this.wrapper, { height: "auto", duration: 0.5 }).
        to(this.iconBox.lastElementChild, { rotate: "180deg" }, 0.1).
        to(this.iconBox.firstElementChild, {
          rotate: "180deg",
          onStart: () => {
            [this.header, this.wrapper, this.iconBox].forEach(v => {
              v.classList.remove("is-hidden");
              v.classList.add("is-show");
            });
          },
          onComplete: () => {      
            if (cardShowMoreClass) {
              cardShowMoreClass.recalculate();
            }
            if(textSearchClass){
              textSearchClass.recalculate();
            }
            followMenuClass.refresh();
          },
          onReverse: () => {
            [this.header, this.wrapper , this.iconBox].forEach(v => {
              v.classList.add("is-hidden");
              v.classList.remove("is-show");
            });
            if (cardShowMoreClass) {
              cardShowMoreClass.recalculate();
            }
            if(textSearchClass){
              textSearchClass.recalculate();
            }
          },
          onReverseComplete: () => {
            if (cardShowMoreClass) {
              cardShowMoreClass.recalculate();
            }
            if(textSearchClass){
              textSearchClass.recalculate();
            }
            followMenuClass.refresh();
          }
        }, 0.1);
      return tl;
    }

    menuOpen = () => {
      if(this.open === true ) return false;
      gsap.to(this.wrapper, {
        height: "auto", duration: 0.5, ease: "power1.out",
        onStart: () => {
          [this.header, this.wrapper, this.iconBox].forEach(v => {
            v.classList.remove("is-hidden");
            v.classList.add("is-show");
          });
        },
        onComplete: () => {
          if (cardShowMoreClass) {
            cardShowMoreClass.recalculate();
          }
          if(textSearchClass){
            textSearchClass.recalculate();
          }
          this.open = true;   
          followMenuClass.refresh();    
        }
      });
    }
    menuClose = () => {
      if( this.open === false ) return false;
      gsap.to(this.wrapper, {
        height: 0, duration: 0.5, ease: "power1.out", onStart: () => {
          [this.header, this.wrapper, this.iconBox].forEach(v => {
            v.classList.add("is-hidden");
            v.classList.remove("is-show");
          });
        },
        onComplete: () => {
          if (cardShowMoreClass) {
            cardShowMoreClass.recalculate();
          }
          if(textSearchClass){
            textSearchClass.recalculate();
          }
          this.open = false;
          followMenuClass.refresh();
        }
      });
    }

    scrollEvent = () => {
      window.scrollTo({
        top: this.topPosition,
        behavior: 'smooth'
      });
    };

    bodyShow = () => {
      gsap.to(this.body, {
        height: "auto", duration: 0.5, ease: "power1.out", onStart: () => {
          this.BtnElement.innerHTML = "<span><span class=\"visible_if_ja\">隠す</span><span class=\"visible_if_en\">Hidden</span><span class=\"visible_if_cn\">隐藏</span><span class=\"material-icons-outlined p-material-icon\">expand_less</span></span>";
        },
         onComplete: () => {
          if (cardShowMoreClass) {
            cardShowMoreClass.recalculate();
          }
          if(textSearchClass){
            textSearchClass.recalculate();
          }
          followMenuClass.refresh();

        }
      });
      [this.body, this.BtnElement].forEach(v => {
        v.classList.remove("is-hidden");
        v.classList.add("is-show");
      });
      
    }
    bodyHidden = () => {
      gsap.to(this.body, {
        height: this.getHeight + "px", duration: 0.3, ease: "power1.out",
        onStart: () => {
          this.BtnElement.innerHTML = "<span><span class=\"visible_if_ja\">さらに表示</span><span class=\"visible_if_en\">Show More</span><span class=\"visible_if_cn\">显示更多</span><span class=\"material-icons-outlined p-material-icon\">expand_more</span></span>";
        },
        onComplete: () => {
          if (cardShowMoreClass) {
            cardShowMoreClass.recalculate();
          }
          if(textSearchClass){
            textSearchClass.recalculate();
          }
          followMenuClass.refresh();

        }
      });
      this.body.appendChild(this.BtnElement);
      [this.body, this.BtnElement].forEach(v => {
        v.classList.add("is-hidden");
        v.classList.remove("is-show");
      });
    }
    toggleOpen = () => {
      if (this.header.classList.contains("is-hidden")) {
        this.menuOpen();
      } else {
        this.menuClose();
      }
    }
    toggleShow = () => {

      if (this.body.classList.contains("is-hidden")) {
        this.bodyShow();
      } else {
        this.bodyHidden();
      }
    }
    setShowMore = () => {
      if (this.tenChild && this.showMore == true ) {
        this.body.style.height = this.getHeight + "px";
        this.body.appendChild(this.BtnElement);
        [this.body, this.BtnElement].forEach(v => v.classList.add("is-hidden"));
      }
    }

    static searchAccordion = (domElement) => {

      let accorionElement = domElement.parentNode.closest( targetClassName );
      
      if( accorionElement === undefined ) return false;

      let targetId = accorionElement.getAttribute("data-accordion-id");

      if( targetId === undefined ) return false;

      let numericTargetId = parseInt(targetId, 10);

      return accordion.instanceList.find( instance =>{ return instance.id === numericTargetId;  });
    }

    static allReset = () => {
      accordion.instanceList.forEach( instance => {

        if(instance.start == 1){
          [instance.header,instance.wrapper,instance.iconBox].map(v2 => {
            v2.classList.add("is-show");
            v2.classList.remove("is-hidden");
            instance.wrapper.style.height = "auto";
          });
        }else{
          [instance.header,instance.wrapper,instance.iconBox].map(v2 => {
            v2.classList.add("is-hidden");
            v2.classList.remove("is-show");
            instance.open = false;
          });
          instance.wrapper.style.height = "0px";
        }
       });
       
    }

    static selectInstance = (boxNum) => {
      const selectInstance = accordion.instanceList.filter( instance => {
        return instance.uniqueNum === parseInt(boxNum);
      });
      if(selectInstance.length > 0) return selectInstance[0];
    }

    static init = () => {
      const bodyShowList = new Set();
      const bodyHiddenList = new Set();

      accordion.instanceList = [...document.querySelectorAll(targetClassName)].map(v => {
        return new accordion(v);
      });

      accordion.instanceList.map( instance => {
       
        const existCheck = paramHandler.jsonData.some(v2 => {
            return instance.unionId.includes(String(v2.PropertyId));
        });

        //パラメータのitemIDを巡回
        const existCheckId = paramHandler.jsonData.some(v2 => {

          const body = instance.body;
          const inputList = body.getElementsByClassName('js__search-item');
          const selectorIds =  v2.ItemIds;

          if( selectorIds === null || selectorIds === undefined ) return false;
          return [...inputList].some( input => {
            return selectorIds.includes( String( input.getAttribute("data-id") ));
          })

        })



        if(existCheck){
          if( instance.union.getAttribute("data-group") ){
            if(existCheckId === true){
              bodyShowList.add(instance);
            }else{
              bodyHiddenList.add(instance);
            }
          }else{
            bodyShowList.add(instance);
          }
        }else{
          if( instance.union.getAttribute("data-group") ){
            if(existCheckId === false && instance.start === false){
              bodyHiddenList.add(instance);
            }else{
              
              if( instance.start == false ){
                bodyHiddenList.add(instance);
              }else{
                bodyShowList.add(instance);
              }
            }
          }else{
            if( instance.start == false ){
              bodyHiddenList.add(instance);
            }else{
              bodyShowList.add(instance);
            }
          }
        }
        instance.setShowMore();
        return instance;
      });
      if(bodyShowList.size> 0){
        bodyShowList.forEach(v => {
          [v.header,v.wrapper,v.iconBox].map(v2 => {
            v2.classList.add("is-show");
            v2.classList.remove("is-hidden");
            v2.open = true;
          })
        });
      }
      if(bodyHiddenList.size> 0){
        bodyHiddenList.forEach(v => {
          [v.header,v.wrapper,v.iconBox].map(v2 => {
            v2.classList.add("is-hidden");
            v2.classList.remove("is-show");
            v2.open = false;
          })
        });
      }
    }
  }

  accordion.init();

  // console.log( accordion.instanceList  );
  return accordion;


}